import AddPet from "./AddPet";
import PetsListItem from "./PetsListItem";
import RecordListItem from "./RecordListItem/RecordListItem";

export default {
    AddPet,
    PetsListItem,
    RecordListItem
};